import { useMutation } from "@tanstack/react-query";
import apiClient from "api/api-client";
import { AxiosResponse } from "axios";
import { FlatApiError } from "types/api";

type ChangePasswordAuthenticatedArgs = {
  currentPassword: string;
  password: string;
};

type ChangePasswordAuthenticatedResponse = {
  passwordChangedAt: string;
};

export const useChangePasswordAuthenticated = () => {
  return useMutation<
    AxiosResponse<ChangePasswordAuthenticatedResponse | FlatApiError>,
    FlatApiError,
    ChangePasswordAuthenticatedArgs
  >({
    mutationFn: (data) =>
      apiClient.patch<ChangePasswordAuthenticatedResponse>("/admin/users/me/password", data),
  });
};
